<template>
  <div>
    <el-breadcrumb class="navcss" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'privatenetplane' }">私有网络平面</el-breadcrumb-item>
      <el-breadcrumb-item>IP地址管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-button type="primary" @click="ipAddrAdd"
                   v-if="btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_add')">新增IP地址</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" row-key="rowKey"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}" style="width: 100%">
      <el-table-column align="center" prop="id" label="ID" width="180"></el-table-column>
      <el-table-column align="center" prop="ipStr" label="IP地址" width="180"></el-table-column>
      <el-table-column align="center" label="有效端口信息">
        <template slot-scope="scope">
          {{convertPortStr(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column align="center" label="IP类型">
        <template slot-scope="scope">
          {{convertIpStr(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ipAttr" label="浮动IP">
        <template slot-scope="scope">
          <span v-if="scope.row.ipAttr==1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operate" label="操作" width="600">
        <template v-slot="{row}">
          <el-button v-if="row.ipType == 2 && btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_reflect')"
                     size="mini" type="primary" @click="netMapClick(row)">内外网映射</el-button>
          <el-button v-if="row.ipType == 2 && btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_edit')"
                     size="mini" type="primary" @click="editIpAddr(row)">编辑</el-button>
          <el-button v-if="row.ipType == 2 && btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_portMap')"
                     size="mini" type="primary" @click="viewPortMapping(row)">查看端口映射</el-button>
          <el-button v-if="row.ipType == 1 && btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_portMap')"
                     size="mini" type="primary" @click="viewWanIpPortMapping(row)">查看端口映射</el-button>
          <el-button v-if="row.ipType == 2 && btnInList('idc_priNetPlane_ipMan','idc_priNetPlane_ipMan_del')"
                     size="mini" type="danger" @click="delConfirm(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    新增IP地址-->
    <el-dialog
      :title="dialogTitle"
      :visible="ipaddr"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%">
      <el-form label-position="left" style="margin-left: 25px;" :model="formData" ref="formData" label-width="70px" :rules="addIpPortrules">
        <el-form-item label="IP地址" prop="ipStr">
          <el-input v-model="formData.ipStr" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="是否浮动IP" prop="ipAttr" label-width="90px">
          <el-radio-group v-model="formData.ipAttr">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="端口" >
          <el-collapse v-model="activePortNames">
            <el-collapse-item name="2" >
              <div v-for="(port, index) in formData.ports" :key="index">
                <el-col :span="20" class="portDiv">
                  <el-form-item  :prop="'ports.'+index+'.value'" :rules="addIpPortrules.port">
                    <el-input v-model="port.value" placeholder="请输入端口号" type="number" min="0"></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon">
                  <div class="el-icon-circle-plus" @click="addPort"></div>
                </el-col>
                <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon"
                        v-if="formData.ports.length > 1">
                  <div class="el-icon-delete-solid" @click="delPort(index)"></div>
                </el-col>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-form-item label="端口范围" >
          <el-collapse>
            <el-collapse-item name="1" >
                <div v-for="(range, index) in formData.portRange" :key="index">
                  <el-col :span="9" class="portDiv">
                    <el-form-item :prop="'portRange.'+index+'.start'" :rules="addIpPortrules.port">
                      <el-input v-model="range.start" type="number" min="0"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col align="center" :span="2">-</el-col>
                  <el-col :span="9" class="portDiv">
                    <el-form-item :prop="'portRange.'+index+'.end'" :rules="addIpPortrules.port">
                      <el-input v-model="range.end" type="number" min="0"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon">
                    <div class="el-icon-circle-plus" @click="addRange"></div>
                  </el-col>
                  <el-col style="margin-top: 6px" align="center" :span="2" class="operateIcon"
                          v-if="formData.portRange.length > 1">
                    <div class="el-icon-delete-solid" @click="delRange(index)"></div>
                  </el-col>
                </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="addIp('formData')">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
<!--    查看端口映射-->
    <el-dialog title="查看端口映射(内→外)" :visible="portmapping"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="60%" @close="close()" :modal=false>
      <el-table :data="mappingArray" style="margin-top: 10px">
        <el-table-column align="center" property="innerIp" label="内网IP"></el-table-column>
        <el-table-column align="center" property="srcPort" label="源端口"></el-table-column>
        <el-table-column align="center" property="protocol" label="协议">
          <template slot-scope="scope">
            <div v-if="scope.row.protocol == 1">UDP</div>
            <div v-else-if="scope.row.protocol == 2">TCP</div>
            <div v-else>TCP/UDP</div>
          </template>
        </el-table-column>
          <el-table-column align="center" property="wanIP" label="外网IP"></el-table-column>
        <el-table-column align="center" property="dstPort" label="目标端口"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="查看端口映射(外→内)" :visible="portmapping1"
               :close-on-click-modal="false"
               :close-on-press-escape="false" width="60%" @close="close()" :modal=false>
      <el-table :data="wanIpmappingArray" style="margin-top: 10px">
        <el-table-column align="center" property="innerIP" label="内网IP"></el-table-column>
        <el-table-column align="center" property="srcPort" label="内网端口"></el-table-column>
        <el-table-column align="center" property="protocol" label="协议">
          <template slot-scope="scope">
            <div v-if="scope.row.protocol == 1">UDP</div>
            <div v-else-if="scope.row.protocol == 2">TCP</div>
            <div v-else>TCP/UDP</div>
          </template>
        </el-table-column>
        <el-table-column align="center" property="dstPort" label="外网端口"></el-table-column>
        <el-table-column align="center" property="wanIp" label="外网IP"></el-table-column>
      </el-table>
    </el-dialog>

    <Net-map v-if="netmap" :netmap="netmap" :idcId="idcId"
             :ipItem="ipItem"
             @editCallback="editCallback"/>
  </div>
</template>

<script>
  import NetMap from './NetMap.vue'
  import { Loading } from "element-ui";
  import {mapMutations, mapState} from "vuex";
  export default {
    name: "IPAddrMan",
    components: {
      NetMap
    },
    data() {
      let IPValidator = (rule, value, callback) => {
        let ip_ip = '(25[0-5]|2[0-4]\\d|1\\d\\d|\\d\\d|\\d)';
        let ip_ipdot = ip_ip + '\\.';
        let isIPaddress = new RegExp('^' + ip_ipdot + ip_ipdot + ip_ipdot + ip_ip + '$');
        if(value == ""){
          callback(new Error('IP地址格式错误'));
          return
        }else if (value && !isIPaddress.test(value)) {
          callback(new Error('IP地址格式错误'));
          return
        } else {
          callback();
        }
      };
      let validateAddport = (rule, value, callback) => {
        if (value == null) {
          return callback()
        }
        const val = Number(value);
        if (val<0 || val>65535){
          callback(new Error('端口范围为 0-65535'));
          return;
        }
        //field---0.portRange/ports   1.下标  2.value/start/end
        const field = rule.field.split('.');
        const ports = this.formData.ports;
        const portRange = this.formData.portRange;
        let arr = new Set(); //所有的端口
        let broPort = [], broRange = [] ;//兄弟端口
        let flag = 0;
        if (field[0] == 'ports') {
          broPort = ports.filter((p, id) => id != Number(field[1]))
          broRange = portRange
        } else {
          broPort = ports;
          broRange = portRange.filter((pr, id) => id != Number(field[1]))
        }
        broPort.forEach(b => {
          if (b.value == null) {
            return
          }
          arr.add(Number(b.value))
        });
        broRange.forEach(br => {
          if (br.start == null || br.end == null) {
            return
          }
          for (let i = Number(br.start); i <= Number(br.end); i++) {
            arr.add(i)
          }
        });
        if (arr.has(val)) {
          callback(new Error('该端口已存在'))
          return
        } else if (field[0] == 'ports') {
          flag = 1;
          arr.add(val)
        } else {
          let start, end;
          if (field[2] == 'start') {
            start = val;
            end = Number(this.formData.portRange[field[1]].end)
          } else {
            end = val;
            start = Number(this.formData.portRange[field[1]].start)
          }
          if (start != 0 && end != 0) {
            if (start >= end) {
              callback(new Error('开始端口要小于结束端口'))
              return
            }
            let note = 0;
            for (let i = start; i <= end; i++) {
              if (arr.has(i)) {
                note = 1;
                break;
              }
            }
            if (note == 0) {
              flag = 1;
              for (let i = start; i <= end; i++) {
                arr.add(i)
              }
            } else {
              callback(new Error('端口已存在'))
            }
          } else if (start == 0 && end == 0) {
            flag = 1
          }
        }
        if (flag == 1) {
          callback()
        }
      };
      return {
        portmapping: false,
        portmapping1:false,
        dialogTitle: "",
        netPlaneId: null,
        idcId: null,
        ipaddr: false,
        netmap: false,
        portMap: false,
        preSaveData: [],
        netIpMappingList: [],
        activePortNames: ['1'],
        tableData: [],
        mappingArray: [],
        mappingArray1:[],
        wanIpmappingArray: [],
        countIdx: 0,
        formData: {
          ipStr: "",
          ipAttr: 0,
          ports: [],
          portRange: []
        },
        ipItem: {},
        portFormData: {
          ports: []
        },
        contentMultipleSelection: [],
        addIpPortrules: {
          port: [{validator: validateAddport, trigger: 'blur'}],
          ipStr: [{required: true, message: '请输入正确IP地址', validator: IPValidator, trigger: 'blur'}]
        },
        // rules: {
        //   port: [{validator: validateport, trigger: 'blur'}],
        // }
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      btnInList() {
        return (name, childName) => {
          let btn = this.listOperations.filter(op => op.name.includes(name));
          if(btn && btn.length>0){
            if (!childName) {
              return btn.length > 0
            } else {
              return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
            }
          }
        }
      },
    },
    methods: {
      ...mapMutations(['getListOperations']),
      delConfirm( id ){
        this.$confirm('您确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(id)
        }).catch(() => {

        });
      },
      del(id){
        let data = {
          id: id
        };
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netip/delete', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.initIpAddrListNew();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      close() {
        this.portmapping = false;
        this.portmapping1 = false
      },
      editCallback(val) {
        if (val) {
          this.initIpAddrListNew();
        }
        this.netmap = false;
        this.portMap = false
      },
      convertIpStr( item ){
        if(item.ipType == 2){
          return "内网"
        }else {
          return "外网"
        }
      },
      convertPortStr( item ) {
        let _portArray = [];
        if (item.portArray) {
          _portArray = _portArray.concat(item.portArray)
        }
        if (item.portRange) {
          item.portRange.forEach(e => {
            _portArray.push(e.start + "-" + e.end)
          })
        }
        let _returnStr = _portArray.join(",");
        return _returnStr
      },
      getRowKey(item) {
        return new Date().getTime();
      },
      netMapClick(item) {
        this.ipItem = item;
        this.contentMultipleSelection = [];
        this.netmap = true;
      },
      ipAddrAdd() {
        this.dialogTitle = "新增IP地址";
        this.formData.ipStr = "";
        this.formData.ipAttr = 0;
        this.id = null;
        this.formData.ports = [];
        this.formData.portRange = [];
        this.formData.ports.push({
          value: null
        });
        this.formData.portRange.push({
          start: null,
          end: null
        });
        this.ipaddr = true
      },
      resetForm() {
        this.ipaddr = false
      },
      addPort() {
        this.formData.ports.push({
          value: null
        });
      },
      addRange() {
        this.formData.portRange.push({
          start: null,
          end: null
        });
      },
      delPort(idx) {
        this.formData.ports.splice(idx, 1);
      },
      delRange(idx) {
        this.formData.portRange.splice(idx, 1);
      },
      addIp(formData) {
        this.$refs[formData].validate((valid) => {
          if (valid) {
            if (this.formData.ports[0].value==null && this.formData.portRange[0].start==null && this.formData.portRange[0].end==null){
              this.$message.warning("请输入端口或端口范围！")
              return
            }
            const loading = this.$loading({
              lock: true,
              text: '加载中...',
              // spinner: 'el-icon-loading',
              background: 'rgba(55, 55, 55, 0.4)'
            });
            let portArray = [];
            for (let content of this.formData.ports) {
              if (content.value != null && content.value != "") {
                portArray.push(Number(content.value))
              }
            }
            let portRange = [];
            for (let content of this.formData.portRange) {
              if (content.start != null && content.end != null) {
                portRange.push({
                  start: Number(content.start),
                  end: Number(content.end)
                })
              }
            }
            var data = {
              'ipStr': this.formData.ipStr,
              'ipType': 2,
              'portArray': portArray,
              'portRange': portRange,
              'idcId': this.idcId,
              'netPlaneId': this.netPlaneId,
              'id': this.id,
              'ipAttr':this.formData.ipAttr
            };
            var _this = this;
            this.$axios.post(this.baseUrl3 + 'management3/netip/update', data)
              .then(({data: {msg, data, code}}) => {
                if (code == 20000) {
                  _this.ipaddr = false;
                  _this.initIpAddrListNew();
                  _this.$message.success("操作成功！");
                } else {
                  _this.$message({showClose: true, message: msg, type: 'error'});
                  console.log(msg)
                }
                loading.close();
              })
              .catch(err => {
                console.log(err);
                setTimeout(() => {
                  loading.close();
                }, 2000);
              })
          } else {
            console.log('请确保端口信息正确且完整');
            return false;
          }
        });
      },
      editIpAddr(item) {
        this.id = item.id;
        // this.formData.ipStr = item.ipStr;
        // this.formData.ipAttr = item.ipAttr;
        this.dialogTitle = "编辑IP地址";
        this.ipaddr = true;
        let data = {
          id: this.id
        };
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netip/get', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.ipaddr = true;
              _this.formData.ipStr = data.ipStr;
              _this.formData.ipAttr = data.ipAttr;
              console.log(data.ipAttr)
              _this.formData.ispId = data.ispId;
              if (data.portArray) {
                _this.formData.ports = [];
                data.portArray.forEach(e => {
                  _this.formData.ports.push({
                    value: e
                  })
                })
              }
              if (data.portRange) {
                _this.formData.portRange = [];
                data.portRange.forEach(e => {
                  _this.formData.portRange.push({
                    start: e.start,
                    end: e.end
                  })
                })
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      viewWanIpPortMapping( item ){
        var data = {
          'id': item.id
        };
        var _this = this;
        _this.wanIpmappingArray = [];
        this.$axios.post(this.baseUrl3 + 'management3/netip/mappinglist', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.portmapping1 = true;
              if (data) {
                data.forEach((e, idx) => {
                  e.portMapping.forEach( row => {
                    _this.wanIpmappingArray.push({
                      id: row.id,
                      protocol: row.protocol,
                      srcPort: row.srcPort,
                      dstPort: row.dstPort,
                      innerIP: e.ipStr,
                      wanIp:item.ipStr
                    })
                  })
                })
              }
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      viewPortMapping(item){
        this.id = item.id;
        let _this = this;
        let children = item.children;
        _this.mappingArray = [];
        if( children && children.length >0 ){
          for(let i=0; i < children.length; i++){
            if(children[i].relationType == 2 && children[i].portMapping && children[i].portMapping.length >0 ){
              children[i].portMapping.forEach( e => {
                _this.mappingArray.push({
                  id: e.id,
                  protocol: e.protocol,
                  srcPort: e.srcPort,
                  dstPort: e.dstPort,
                  wanIP: children[i].ipStr,
                  innerIp:item.ipStr,
                })
              })
            }
          }
        }
        this.dstPort = item.dstPort;
        this.protocol = item.protocol;
        this.srcPort = item.srcPort;
        this.relationType = item.relationType;
        this.portmapping = true;
      },
      initIpAddrListNew() {
        var data = {
          'pageNo': 1,
          'pageSize': 10000000,
          'condition': this.condition,
          'netPlaneId': this.netPlaneId,
          'type': 2
        };
        var _this = this;
        _this.tableData = [];
        this.$axios.post(this.baseUrl3 + 'management3/netip/listWithChildren', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              if (data && data.IpList) {
                data.IpList.forEach((e, idx) => {
                  e.rowKey = e.id + "";
                  if (e.children) {
                    e.children.forEach(child => {
                      child.rowKey = e.id + "_" + child.ipStr
                    })
                  }
                })
              }
              _this.tableData = data && data.IpList ? data.IpList : [];
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initIpAddrList() {
        var data = {
          'pageNo': 1,
          'pageSize': 10000000,
          'condition': this.condition,
          'netPlaneId': this.netPlaneId,
          'type': 2
        };
        var _this = this;
        _this.tableData = [];
        this.$axios.post(this.baseUrl3 + 'management3/netip/list', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.tableData = data && data.IpList ? data.IpList : [];
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSelectionChange() {

      },
    },
    created() {
      this.getListOperations('idclist')
      if (!this.currentMenu) {
        return
      }
      this.idcId = parseInt(this.$route.params.idcId);
      this.netPlaneId = parseInt(this.$route.params.netPlaneId);
      this.initIpAddrListNew();
    },
    mounted() {
      this.portFormData.ports.push({
        srcPort: null,
        dstPort: null
      });
      this.formData.ports.push({
        value: null
      });
      this.formData.portRange.push({
        start: null,
        end: null
      })
    },
  }
</script>

<style >
  .el-loading-spinner {
    background-image:url('../../../assets/loading1.svg');
    background-size:63px 100px;
    background-repeat: no-repeat;
    height:30%;
    background-position:center;
    top:200px;
  }
  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
  .navcss {
    font-size: 17px;
    margin-bottom: 15px;
  }

  .portDiv {
    margin-bottom: 20px;
  }
</style>
